export enum LumpsumPlansPlanType {
  ALLOCATION = 'ALLOCATION',
  REBALANCE = 'REBALANCE',
  IDEAL = 'IDEAL'
}

/**
 * Pre-plan + rolled-out lifecycle for lumpsum tabs.
 * - QUESTIONNAIRE_NOT_INITIATED → Find your strategy
 * - QUESTIONNAIRE_IN_PROGRESS → Complete your strategy
 * - QUESTIONNAIRE_SUBMITTED / QUESTIONNAIRE_RE_SUBMITTED → timer / delayed
 * - PLAN_ROLLED_OUT → plan list (replaces old `isPlanAvailable`)
 */
export enum LumpsumPlanStatus {
  QUESTIONNAIRE_NOT_INITIATED = 'QUESTIONNAIRE_NOT_INITIATED',
  QUESTIONNAIRE_IN_PROGRESS = 'QUESTIONNAIRE_IN_PROGRESS',
  QUESTIONNAIRE_SUBMITTED = 'QUESTIONNAIRE_SUBMITTED',
  QUESTIONNAIRE_RE_SUBMITTED = 'QUESTIONNAIRE_RE_SUBMITTED',
  PLAN_ROLLED_OUT = 'PLAN_ROLLED_OUT'
}

export enum LumpsumRecommendationActionType {
  BUY = 'BUY',
  SELL = 'SELL'
}

export enum LumpsumRecommendationType {
  ACTIONABLE = 'ACTIONABLE',
  UNDER_REVIEW = 'UNDER_REVIEW',
  EXECUTED = 'EXECUTED',
  INVALIDATED = 'INVALIDATED',
  NO_ACTION = 'NO_ACTION'
}

export enum LumpsumRecommendationStatus {
  NEW = 'NEW',
  UPDATED = 'UPDATED',
  SAME = 'SAME',
  INVALIDATED = 'INVALIDATED'
}

export enum LumpsumRecommendationSubType {
  INVALIDATED_ACTIONABLE = 'INVALIDATED_ACTIONABLE',
  INVALIDATED_UNDER_REVIEW = 'INVALIDATED_UNDER_REVIEW'
}

export interface LumpsumIdealAllocation {
  absolute?: number | null
  upperLimit?: number | null
  lowerLimit?: number | null
}

export interface LumpsumFund {
  isin?: string | null
  mfLogoUrl?: string | null
  fundName?: string | null
  fundNature?: string | null
  fundCategory?: string | null
  purchaseMode?: string | null
  distributionStatus?: string | null
  currentValue?: number | null
  currentAllocationPercentage?: number | null
  powerRank?: number | null
  powerRating?: string | null
  taxCategory?: string | null
}
